import React, { createContext, useContext, useState, useEffect } from 'react';
import { subscribeToBranches } from '../firebase/branchService';

const BranchContext = createContext(null);

export const BranchProvider = ({ children, currentUser }) => {
  const [branches, setBranches] = useState([]);
  const [activeBranch, setActiveBranch] = useState(null);
  const [loading, setLoading] = useState(true);

  const isAdmin = currentUser?.role === 'admin';

  useEffect(() => {
    const unsub = subscribeToBranches((data) => {
      setBranches(data);

      // Restore last selected branch from localStorage
      const saved = localStorage.getItem('activeBranchId');

      if (isAdmin) {
        // Admin: can switch between branches; default to saved or first
        if (saved) {
          const found = data.find((b) => b.id === saved);
          setActiveBranch(found || data[0] || null);
        } else {
          setActiveBranch(data[0] || null);
        }
      } else {
        // Staff: locked to their assigned branch
        const assigned = data.find((b) => b.id === currentUser?.branchId);
        setActiveBranch(assigned || null);
      }

      setLoading(false);
    });
    return () => unsub();
  }, [currentUser, isAdmin]);

  const switchBranch = (branchId) => {
    if (!isAdmin) return; // only admin can switch
    const found = branches.find((b) => b.id === branchId);
    if (found) {
      setActiveBranch(found);
      localStorage.setItem('activeBranchId', branchId);
    }
  };

  return (
    <BranchContext.Provider value={{ branches, activeBranch, switchBranch, loading, isAdmin }}>
      {children}
    </BranchContext.Provider>
  );
};

export const useBranch = () => {
  const ctx = useContext(BranchContext);
  if (!ctx) throw new Error('useBranch must be used within BranchProvider');
  return ctx;
};
